import React, { useContext, useEffect, useState } from 'react'
import classnames from 'classnames'

import { LanguageContext } from 'context/LanguageContext'
import { ScreenContext } from 'context/ScreenContext'
import { sendPhoneNumber } from 'modules/contactUs/sagas'
import { getCDNURL } from 'network/api/networkSettings'

const normalizeInput = (value, previousValue) => {
    if (!value) return value
    const currentValue = value.replace(/[^\d]/g, '')
    const cvLength = currentValue.length

    if (!previousValue || value.length > previousValue.length) {
        if (cvLength < 4) return currentValue
        if (cvLength < 7) return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`
        return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3, 6)}-${currentValue.slice(
            6,
            10
        )}`
    }
}

const PhoneNumber = ({
    feedback,
    defaultValue,
    field = {},
    onChange,
    onBlur,
    errorInput,
    shouldHidePrefix,
    labelText,
    className,
    customCssFlag,
    inLandingPageBody,
}) => {
    const { rtl, strings } = useContext(LanguageContext)

    const { screen } = useContext(ScreenContext)
    const [number, setNumber] = useState(defaultValue)
    const [disableBtn, updateDisableBtn] = useState(true)
    const [showSuccess, updateSuccessMsg] = useState(false)
    const isDesktop = screen >= 992

    useEffect(() => {
        validatePhoneNumber(number) ? updateDisableBtn(false) : updateDisableBtn(true)
    }, [number])

    const handleFormat = e => {
        const { value } = e.target
        const phoneNumber = normalizeInput(value, number)
        setNumber(phoneNumber)
        if (phoneNumber) {
            const rawValue = phoneNumber.replace(/[^\d]/g, '')

            if (feedback) {
                feedback(rawValue, phoneNumber)
            }

            if (onChange) {
                e.target.value = rawValue
                onChange(e)
            }
        }
    }

    const validatePhoneNumber = input_str => {
        const re = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im
        return re.test(input_str)
    }

    const handleSend = e => {
        e.preventDefault()
        const rawValue = number.replace(/[^\d]/g, '')
        sendPhoneNumber(rawValue).then(res => {
            if (res.status === 'success') {
                updateSuccessMsg(true)
                setTimeout(() => {
                    setNumber('')
                    updateSuccessMsg(false)
                }, 3000)
            }
        })
    }

    const renderLabel = () => (
        <label className="phone-number-label" htmlFor="phoneNumber">
            {labelText}
        </label>
    )

    const phoneNumberClassName = classnames('phone-number-input-number', { errorLine: errorInput })
    const phoneNumberCodeClassName = classnames('phone-number-input-code', {
        errorLine: errorInput,
    })

    const successMsg = () => (
        <div
            className={`${
                isDesktop
                    ? `${customCssFlag ? 'downloadLink__success' : 'downloadLink__successBdy'}`
                    : 'downloadLink__successBdy'
            } ${inLandingPageBody && !customCssFlag ? 'alignFlexSt' : null}`}
        >
            <img
                className="downloadLink__success-img"
                src={getCDNURL() + 'assets/images/check_circle.png'}
                alt=""
            ></img>
            <p className="downloadLink__success-text">{strings.downloadLinkSuccess}</p>
        </div>
    )

    return (
        <div className={classnames('phone-number', className)}>
            {labelText && renderLabel()}
            <div className="phone-number-container">
                <div
                    className="phone-number-container-wrapper"
                    style={rtl ? { marginLeft: 'unset' } : {}}
                >
                    {!shouldHidePrefix && (
                        <input type="text" className={phoneNumberCodeClassName} placeholder="+1" />
                    )}
                    <input
                        type="tel"
                        id="phoneNumber"
                        className={phoneNumberClassName}
                        style={
                            rtl
                                ? {
                                      borderLeft: 'unset',
                                      borderRight: '1px solid rgb(151, 151, 151)',
                                  }
                                : {}
                        }
                        placeholder="(123) 555-5555"
                        onChange={handleFormat}
                        value={number || ''}
                        {...field}
                        onBlur={onBlur}
                    />
                </div>
                {
                    <button
                        className={`phone-number-${disableBtn ? 'disabled' : 'submit'}`}
                        type="submit"
                        disabled={disableBtn ? true : false}
                        onClick={handleSend}
                    >
                        {showSuccess ? (
                            inLandingPageBody && !customCssFlag ? (
                                <img
                                    className="phone-number-submit-tickImg"
                                    src={getCDNURL() + 'assets/images/white-tick.png'}
                                ></img>
                            ) : (
                                <img
                                    className="phone-number-submit-tickImg"
                                    src={
                                        isDesktop
                                            ? getCDNURL() + 'assets/images/green-tick.webp'
                                            : getCDNURL() + 'assets/images/white-tick.png'
                                    }
                                ></img>
                            )
                        ) : (
                            strings.FOOTER_DOWNLOAD_BUTTON
                        )}
                    </button>
                }
            </div>
            {showSuccess && successMsg()}
        </div>
    )
}

PhoneNumber.defaultProps = {
    shouldHidePrefix: false,
    disableSendButton: false,
}

export default PhoneNumber
